import React, { useState } from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { List, HouseDoor, QuestionCircle, FileText, ShieldCheck } from 'react-bootstrap-icons';
import './NavBar.css';

const NavBar: React.FC = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button onClick={handleShow} className="navbar-toggle-btn">
        <List />
      </Button>

      <Offcanvas show={show} onHide={handleClose} placement="start" className="custom-offcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>CryptoSwappie</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="nav-menu-items">
            <li>
              <Link to="/" className="nav-link" onClick={handleClose}>
                <HouseDoor className="me-2" /> Home
              </Link>
            </li>
            <li>
              <Link to="/faq" className="nav-link" onClick={handleClose}>
                <QuestionCircle className="me-2" /> FAQ
              </Link>
            </li>
            <li>
              <Link to="/terms" className="nav-link" onClick={handleClose}>
                <FileText className="me-2" /> Terms
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="nav-link" onClick={handleClose}>
                <ShieldCheck className="me-2" /> Privacy
              </Link>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default NavBar;